<div class="row upload-row">
  <div *ngIf="!uploadLoading" [ngClass]="uploadingStart ? 'col-sm-10 offset-sm-1 col-md-10 offset-md-1 col-blueGDPR' : 'col-sm-10 offset-sm-1 col-md-10 offset-md-1 col-blueGDPR justify-content-center'">
    <div class="uploaded-file-processing-status" *ngIf="uploadingStart">
      <app-anonymization-status [documents]="documentsDuringAnonimization" [uploader]="uploader"
                                [uploadingFileStatus]="uploadingFileStatus" (deletedItem)="deleteAnonymizeFile($event)"
                                (downloadAll)="downloadAll()">
      </app-anonymization-status>
    </div>

    <div class="card-blueGDPR">
      <form [formGroup]="form">
        <div ng2FileDrop
             (fileOver)="fileOverBase($event)"
             [uploader]="uploader"
             (onFileDrop)="dropped($event)"
             class="drop-down-zone" >

          <div class="upload-files" @dropDownZone>
            <img [src]="hasBaseDropZoneOver ? './assets/ui/svg/grey/grey-upload-big-animated.svg' : './assets/ui/svg/grey/grey-upload-big.svg'" class="upload-icon">
            <h1>Drag and drop zone</h1>
            <div class="d-flex flex-row justify-content-center w-100">
              <div class="upload-button-section">
                <label for="upload-button" class="upload-label">Browse</label>
                <input type="file" ng2FileSelect [uploader]="uploader" name="document" multiple id="upload-button" #uploadButton (change)="onChange($event)" />
              </div>

              <div class="upload-button-section" *ngIf="dicomDirectoryUploaderVisible">
                <label for="upload-directory-button" class="upload-label">DICOM folder</label>
                <input #folderInput type="file" (change)="uploadDicoms(folderInput.files, $event)" id="upload-directory-button" webkitDirectory>
              </div>
            </div>
          </div>

          <div *ngIf="supportedFiles.length > 0" class="supported-files" @supportedFilesList>
            <div *ngFor="let sf of supportedFiles" class="supported-file" @sfItem>
              <img [src]="sf.img">
              <div class="left-part">
                <div class="title">{{sf.title }}</div>
                <div class="extension">{{sf.extension}}</div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

  </div>
  <div *ngIf="uploadLoading" class="d-flex flex-column justify-content-center align-items-center loader-section">
    <img src="./assets/ui/svg/grey/grey-upload-animation-forever.svg">
    <span>Loading...</span>
  </div>

</div>

